export enum EmailProviderEnum {
  SMTP,
  NYLAS,
}
